const importers = {
        './test/AvoidOverlapChoices.stories.ts': async () => import('/@fs//home/runner/work/avoid-overlap/avoid-overlap/test/AvoidOverlapChoices.stories.ts'),
  './test/AvoidOverlapNudge.stories.ts': async () => import('/@fs//home/runner/work/avoid-overlap/avoid-overlap/test/AvoidOverlapNudge.stories.ts'),
  './test/real-world-exports.stories.ts': async () => import('/@fs//home/runner/work/avoid-overlap/avoid-overlap/test/real-world-exports.stories.ts')
    };

    export async function importFn(path) {
        return importers[path]();
    }